import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import MobileMenuPageHeader from '../../header/MobileMenuPageHeader';
import Footer from '../../Footer';

const headerHeight = 120;
const footerHeight = 24;

const styles = {
  main: {
    height: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
    display: 'flex',
    flexWrap: 'wrap',
    background: '#222',
  },
  menuItem: {
    height: `calc((100vh - ${headerHeight}px - ${footerHeight}px)/2)`,
    width: 'calc(100vw/2)',
    display: 'flex',
    flexDirect: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    textDecoration: 'none',
    color: 'white',
    border: 0,
  },
};

const MapPageMobile = () => (
  <>
    <MobileMenuPageHeader height={headerHeight} />
    <main id="menu-items-wrapper" style={styles.main}>
      <Link
        to="/map"
        style={{ ...styles.menuItem, borderTop: '5px #121212 solid', borderRight: '5px #121212 solid' }}
      >
        <Typography variant="h6">Map</Typography>
      </Link>
      <Link
        to="/about"
        style={{ ...styles.menuItem, borderTop: '5px #121212 solid' }}
      >
        <Typography variant="h6">About</Typography>
      </Link>
      <Link
        to="/help"
        style={{ ...styles.menuItem, borderTop: '5px #121212 solid', borderRight: '5px #121212 solid', borderBottom: '5px #121212 solid' }}
      >
        <Typography variant="h6">Help</Typography>
      </Link>
      <Link
        to="/contact"
        style={{ ...styles.menuItem, borderTop: '5px #121212 solid', borderBottom: '5px #121212 solid' }}
      >
        <Typography variant="h6">Contact Us</Typography>
      </Link>
    </main>
    <Footer height={footerHeight} />
  </>
);

export default MapPageMobile;
